import './Services.css';

const SERVICES = [
  {
    title: 'Bioequivalence (BE) Report Review',
    desc: 'Scientific BE expert report review, statistical analysis, literature review, protocol evaluation and regulatory documentation.',
  },
  {
    title: 'Bioequivalence Studies',
    desc: 'Complete management of bioequivalence studies from protocol development to final study reports.',
  },
  {
    title: 'Pharmacovigilance',
    desc: 'Comprehensive drug safety services including ICSR processing, signal detection, aggregate reports and safety monitoring.',
  },
  {
    title: 'Reference Listed Drug Supply',
    desc: 'Global sourcing and procurement of innovator products for bioequivalence studies and regulatory submissions.',
  },
  {
    title: 'Animal Studies',
    desc: 'Preclinical pharmacology, toxicology, efficacy and safety studies through accredited research facilities.',
  },
  {
    title: 'DMF Support',
    desc: 'Preparation, review, lifecycle management and regulatory support for Drug Master Files.',
  },
  {
    title: 'Dossier Preparation & eCTD',
    desc: 'CTD, ACTD and eCTD publishing services for global regulatory submissions.',
  },
  {
    title: 'Regulatory Filing Support',
    desc: 'End-to-end support for submissions to US FDA, EMA, CDSCO, MHRA, GCC, ASEAN and other international regulatory agencies.',
  },
];

function DiamondIcon() {
  return (
    <span className="service__icon">
      <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
        <circle cx="12" cy="12" r="4" fill="currentColor" />
      </svg>
    </span>
  );
}

function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Our Services</span>
          <h2 className="section-title">Comprehensive Regulatory &amp; Scientific Solutions</h2>
        </div>

        <div className="services">
          {SERVICES.map((service) => (
            <div className="service-card" key={service.title}>
              <DiamondIcon />
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__desc">{service.desc}</p>
            </div>
          ))}

          <div className="service-card service-card--cta">
            <h3>We&rsquo;re here to help!</h3>
            <p>
              Looking for bioequivalence, regulatory or pharmacovigilance
              support? Reach out and let&rsquo;s talk.
            </p>
            <a href="tel:+919003069189" className="service-card__phone">
              +91 90030 69189
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
